import React from 'react'
import styled from "styled-components";

const Line = styled.div`
    position: absolute;
    left: -5%;
    width: fit-content;
    height: 100%;
    bottom: 0;

    @media (min-width: 1920px){
        left: 0;
    }

    @media (max-width: 1620px){
        display: none;
    }
`;

const Body = styled.div`
    width: 2px;
    height: 70%;
    border-left: 2px dashed #38393B;
    position: absolute;
    top: 13%;
    left: 122px;
    z-index: 9999;
`;

export const Top = styled.div`
    width: 2px;
    height: 15%;
    border-left: 2px dashed #38393B;
    position: absolute;
    top: 0px;
    left: 200px;
    z-index: 9999;
    transform: rotate(45deg);
`;

export const Bottom = styled.div`
    width: 2px;
    height: 20%;
    border-left: 2px dashed #38393B;
    position: absolute;
    bottom: -4px;
    left: 18px;
    z-index: 9999;
    transform: rotate(45deg);
`;

const AbstractLine = () => {
    return (
        <Line>
            <Top />
            <Body />
            <Bottom />
        </Line>
    )
}

export default AbstractLine
